import * as tus from "tus-js-client";
import {Ref} from "vue";
import {ProgressStatus} from "../target/api/de/moovit/titletoolserver/model";

/** Stage 0 of the progress display, which tus drives instead of the websocket. */
export interface UploadProgressRefs {
  currentStage: Ref<number | undefined>;
  currentStatus0: Ref<ProgressStatus | undefined>;
  currentProgress0: Ref<number | undefined>;
  currentProgress: Ref<number | undefined>;
  message: Ref<string | undefined>;
  error: Ref<boolean | undefined>;
}

/** Starts a resumable asset upload against the embedded tus server. */
export function startAssetUpload(
  file: File,
  assetId: string,
  sessionId: string,
  refs: UploadProgressRefs
): tus.Upload {
  // tus resolves the upload location against this, so it has to be absolute
  const endpoint = new URL(
    `${process.env.VUE_APP_TT_ENDPOINT}/tus`,
    window.location.origin
  ).toString();

  const upload = new tus.Upload(file, {
    endpoint: endpoint,
    // one patch per file would die at the 100mb cloudflare body cap; this also keeps a chunk
    // inside the 60s nginx proxy_read_timeout, since the 204 only comes once the chunk has landed
    chunkSize: 10 * 1024 * 1024,
    retryDelays: [0, 1000, 3000, 5000, 10000, 30000],
    removeFingerprintOnSuccess: true,
    // read per request: an upload can outlive the token it started with
    onBeforeRequest: (req: tus.HttpRequest) => {
      req.setHeader(
        "Authorization",
        "Bearer " + JSON.parse(localStorage.loginData).access_token
      );
    },
    metadata: {
      assetId: assetId,
      sessionId: sessionId,
      filename: file.name,
    },
    onProgress: (bytesSent: number, bytesTotal: number) => {
      refs.currentStage.value = 0;
      refs.currentStatus0.value = ProgressStatus.UPLOADING;
      refs.currentProgress0.value = Math.round((bytesSent / bytesTotal) * 100);
      refs.currentProgress.value = refs.currentProgress0.value;
    },
    onSuccess: () => {
      refs.currentProgress0.value = 100;
      refs.currentProgress.value = 100;
    },
    onError: (err: Error) => {
      console.error("upload failed", err);
      refs.message.value = err.message;
      refs.error.value = true;
    },
  });

  upload.start();
  return upload;
}
